export const enumPermisosDepositosMasivo = Object.freeze({
  DEPOSITO_MASIVO_CARGUE: 42000,
  DEPOSITO_MASIVO_CONSULTA: 42001,
});
export const enumPermisosDepositosMasivoOperaciones = Object.freeze({
  DEPOSITO_MASIVO_CONSULTA_OPERACIONES: 42002,
});
